// Shared between DictionaryView.js (renders the glossary) and svgTermMatch.js (cross-references
// diagram text against it) — kept in one place so both always agree on what a "term" is and how
// its anchor id is built.

export function parseDictionary(text) {
  const lines = (text || "").split(/\r?\n/);
  const entries = [];
  let current = null;
  for (const raw of lines) {
    const line = raw.trim();
    if (!line) continue;
    const bullet = line.match(/^-\s*(.+)$/);
    if (bullet) {
      if (current) entries.push(current);
      current = { term: bullet[1].trim(), lines: [] };
    } else if (current) {
      current.lines.push(line);
    }
  }
  if (current) entries.push(current);
  return entries.map((e) => ({ term: e.term, definition: e.lines.join(" ") }));
}

export const slugifyTerm = (text) =>
  text.toLowerCase().trim().replace(/[^a-z0-9\s-]/g, "").replace(/\s+/g, "-");
